import React from 'react';

import {
    Create,
    SelectInput,
    SimpleForm,
    TextInput,
    ReferenceInput,
    BooleanInput,
} from 'react-admin';

const WarehouseCreate = props => (
    <Create {...props}>
        <SimpleForm variant="outlined">
            <TextInput disabled source="partnerId" defaultValue="1" />
            <TextInput source="name" />
            <ReferenceInput
                label="City"
                source="cityId"
                reference="city"
                resource="city"
            >
                <SelectInput optionText="name" />
            </ReferenceInput>
            <ReferenceInput
                label="Country"
                source="countryId"
                reference="country"
                resource="country"
            >
                <SelectInput optionText="name" />
            </ReferenceInput>
            <BooleanInput source="active" />
        </SimpleForm>
    </Create>
);

export default WarehouseCreate;
